import { Pipe, PipeTransform } from '@angular/core';
import { PadNumberType, padNumberPrefixDict } from '@prism/prism-shared';

export function padNumber(
    value: string | number,  
    type: PadNumberType = PadNumberType.DefaultType,  
    character = '0', 
    front = true
) {
    const count = padNumberPrefixDict[type]
    
    if (typeof value === 'number') {
        value = value.toString();
    }
    if (value.length >= count) {
        return value;
    }
    const padding = Array(count - value.length).fill(character).join('')
    return front ? padding + value : value + padding;
}

@Pipe({name: 'padNumber'})
export class PadNumberPipe implements PipeTransform {
    transform(
        value: string | number, 
        type: PadNumberType = PadNumberType.DefaultType, 
        character = '0', 
        front = true
    ): any {
        return padNumber(value, type, character, front)
    }
}